import { RenderLeafProps } from 'slate-react';

// Editor renders Slate 'marks' (formatting) in the following ways:
export const Leaf = ({ attributes, children, leaf }: RenderLeafProps) => {
	if (leaf.bold) {
		children = <strong>{children}</strong>;
	}
	if (leaf.italic) {
		children = <em>{children}</em>;
	}
	if (leaf.underline) {
		children = <u>{children}</u>;
	}
	if (leaf.strikethrough) {
		children = <s>{children}</s>;
	}

	return <span {...attributes}>{children}</span>;
};
